module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content info"
  }, [_c('div', {
    staticClass: "grid-noBottom"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.category
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.category))])]), (_vm.subpage) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.parent
      }
    }
  }, [_c('h3', {
    staticClass: "h-sm parent",
    style: (_vm.textColor)
  }, [_vm._v(_vm._s(_vm.parentTitle.toLowerCase()))])]) : _vm._e(), _c('h1', {
    staticClass: "h-xl",
    style: (_vm.textColor)
  }, [_vm._v(_vm._s(_vm.loadedData[_vm.key].title))]), _c('ul', _vm._l((_vm.children), function(child) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/' + child.uri
        }
      }
    }, [_c('h3', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(child.content.title.toLowerCase()))])])], 1)
  })), _c('h4', {
    staticClass: "h-sm share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), (_vm.url) ? _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.url,
      "alt": _vm.parentTitle
    }
  })]), (_vm.heroCaptions) ? _c('div', {
    staticClass: "captions-hero"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.heroCaptions)
    }
  })]) : _vm._e()]) : _vm._e(), (_vm.url) ? _c('div', {
    staticClass: "col-5_xs-12",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.gallery) ? _c('swiper', {
    ref: "info-gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2) : _vm._e()], 1) : _c('div', {
    staticClass: "col-5_xs-12"
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.gallery) ? _c('swiper', {
    ref: "info-gallery",
    staticClass: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.gallery), function(image) {
    return _c('swiper-slide', {
      key: image.title
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": image.url
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2) : _vm._e()], 1), _c('div', {
    staticClass: "col-3_xs-12"
  }, [_c('div', {
    staticClass: "box wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.box)
    }
  })])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8728e9fc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoPage.vue
// module id = 243
// module chunks = 1